<template>
  <div class="file-grids">
    <div v-for="file in files" :key="file.id" class="file-grid">
      <div class="file-grid-actions">
        <slot name="actions" :file="file" />
      </div>
      <div class="file-grid-thumbnail">
        <img
          v-if="getFileType(file.filename) == 'image'"
          :src="prependApiDomain(file.path)"
        />
        <VuePdfEmbed
          v-else-if="getFileType(file.filename) == 'pdf'"
          :source="prependApiDomain(file.path)"
          height="130"
          :page="1"
        />
        <v-icon v-else size="64">
          {{ getExtensionIcon(file.filename) }}
        </v-icon>
      </div>
      <div class="file-grid-filename">
        <a :href="prependApiDomain(file.path)" target="_blank">{{
          file.filename
        }}</a>
      </div>
    </div>
  </div>
</template>
<script>
import { defineComponent } from "vue";
import gql from "fraql";
import VuePdfEmbed from "vue-pdf-embed";
import { prependApiDomain } from "@/utils/prependApiDomain";

export default defineComponent({
  name: "AppFilesGrid",
  components: {
    VuePdfEmbed
  },
  props: {
    files: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    prependApiDomain,
    getFileType(filename) {
      const splitted = filename.split(".");
      const extension = splitted[splitted.length - 1].toLowerCase();
      switch (extension) {
        case "png":
        case "jpeg":
        case "jpg":
        case "webp":
        case "gif":
          return "image";
        case "pdf":
          return "pdf";
        default:
          return "$iconPage";
      }
    },
    getExtensionIcon(filename) {
      const splitted = filename.split(".");
      const extension = splitted[splitted.length - 1].toLowerCase();

      switch (extension) {
        case "png":
        case "jpeg":
        case "jpg":
        case "webp":
        case "gif":
          return "$iconImage";
        default:
          return "$iconPage";
      }
    }
  },
  fragments: {
    attachedFileFields: gql`
      fragment _ on AttachedFile {
        id
        filename
        path
      }
    `,
    uploadedFileFields: gql`
      fragment _ on UploadedFile {
        id
        filename
        path
      }
    `
  }
});
</script>
<style lang="scss" scoped>
.file-grids {
  display: grid;
  grid-column-gap: 16px;
  grid-row-gap: 2em;
  grid-template-columns: repeat(auto-fit, 250px);

  .file-grid {
    padding: 12px;
    display: flex;
    flex-direction: column;
    //align-items: center;

    border: 1px solid #c6c2c2;
    border-radius: 0.25em;

    &:hover,
    &:focus {
      background-color: #f3f3f3;
    }

    .file-grid-actions {
      width: 100%;
      text-align: end;
    }

    .file-grid-thumbnail {
      display: flex;
      justify-content: center;
      padding-bottom: 12px;
      flex-grow: 1;
      min-height: 130px;
      img {
        object-fit: cover;
        width: 100%;
        height: 130px;
      }
    }

    .file-grid-filename {
      text-align: center;
    }
  }
}
</style>
